import { flashTypes } from '@components/base/mr-flash-message';
import { SessionStatus } from '@clients/SupportApi';

export enum ActivityType {
    Question = 'Question',
    Form = 'Form',
    Other = 'Other',
    FinalActivity = 'FinalActivity',
}

export enum InfoBoxType {
    Danger = 'Danger',
    Warning = 'Warning',
    Info = 'Info',
}

export const InfoBoxTypeMapper = {
    [InfoBoxType.Danger]: flashTypes.error,
    [InfoBoxType.Warning]: flashTypes.warning,
    [InfoBoxType.Info]: flashTypes.info,
};

export enum FormInputType {
    Text = 'Text',
    MultilineText = 'MultilineText',
    File = 'File',
    Rating = 'Rating',
}

export enum FormInputComponents {
    MrInput = 'MrInput',
    FileUploader = 'FileUploader',
    MrRating = 'MrRating',
}

export enum FileTypes {
    Documentation = 'Documentation',
    Image = 'Image',
    Other = 'Other',
}

export type InfoBox = {
    message: string;
    infoBoxType: InfoBoxType;
};

export interface QuestionData {
    key: number;
    title: string;
    subTitle: string;
    metaData: string;
    value: string;
    isSelected: boolean;
    needApproval?: boolean;
    validationRegex?: string;
    questionOptionType: QuestionOptionType;
    needLogin?: boolean;
    chooseBillOptionInfo?: ChooseBillOptionInfo;
}

enum ReserveTypes {
    Bus = 'Bus',
    Train = 'Train',
    Hotel = 'Hotel',
    Flight = 'Flight',
    SuggestedService = 'SuggestedService',
    Other = 'Other',
}

enum BillSupportStatus {
    Finalized = 'Finalized',
    Canceled = 'Canceled',
    Pending = 'Pending',
    UnsuccessfulBuy = 'UnsuccessfulBuy',
    MultiTickets = 'MultiTickets',
    Unknown = 'Unknown',
}

export interface ChooseBillOptionInfo {
    origin?: string;
    destination?: string;
    departureTime?: string;
    billCode?: string;
    hotelName?: string;
    reserveTypes?: ReserveTypes[];
    billStatus?: BillSupportStatus;
}

export type FormInput = {
    key: number;
    title: string;
    persianTitle: string;
    description: string;
    formInputType: FormInputType;
    regexPattern?: string;
    fileType?: FileTypes;
    value: string;
    isRequired?: boolean;
};

export interface SupportStepData {
    workflowInstanceId: string;
    activityId: string;
    uniqueId: string;
    sessionId: number;
    activityName: string;
    activityType: ActivityType;
    /**
     * @deprecated
     */
    questionType?: never;
    needFurtherReviewButton?: boolean;
    hasReturnButton?: boolean;
    ticketActivityState?: TicketActivityStates;
    activityTitle: string;
    activitySubTitle: string;
    activityDescription: string;
    welcomeText: string;
    infoBoxes: InfoBox[];
    questionOptions: QuestionData[] | null;
    formInputs?: FormInput[];
    resultFormat: 'JSON';
    questionText: string;
    token: string;
    canBackToPreviousActivityAfterExecution: boolean;
    modifiedAt: string;
    isWorkflowFinalStep?: boolean;
    submitButtonText?: string;
    needLogin?: boolean;
}

export type FormDataItem = {
    key: number;
    value: string;
};

export type SupportFormData = {
    ActivityId: string;
    WorkflowInstanceId: string;
    Items: FormDataItem[];
};

export interface IFormField<T> {
    value: T | null;
    key: number;
    label: string;
    description: string;
    isValid: boolean;
    isRequired?: boolean;
    validator: (val: T) => string | true;
    updateValue: (val: T) => void;
    validateCurrentField: () => string | true;
    data: string;
}

export enum WorkflowStates {
    'idle' = 'idle',
    'loading' = 'loading',
    'error' = 'error',
    'reconnecting' = 'reconnecting',
    'closed' = 'closed',
}

export const SupportSessionStatus: Record<
    keyof typeof SessionStatus | 'PreRegister',
    SessionStatus | 'PreRegister'
> = {
    ...SessionStatus,
    PreRegister: 'PreRegister',
};

export type SupportSessionStatus =
    (typeof SupportSessionStatus)[keyof typeof SupportSessionStatus];

export enum QuestionOptionType {
    'Link' = 'Link',
    'Editable' = 'Editable',
    'Normal' = 'Normal',
    'ChooseBill' = 'ChooseBill',
}

export enum TicketActivityStates {
    Requested = 'Requested',
    UnderReview = 'UnderReview',
    Succeed = 'Succeed',
    Failed = 'Failed',
}
